import { render, staticRenderFns } from "./DomainSummaryStatsCard.vue?vue&type=template&id=1650ac1d&scoped=true"
import script from "./DomainSummaryStatsCard.vue?vue&type=script&lang=js"
export * from "./DomainSummaryStatsCard.vue?vue&type=script&lang=js"
import style0 from "./DomainSummaryStatsCard.vue?vue&type=style&index=0&id=1650ac1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650ac1d",
  null
  
)

export default component.exports